import { render, staticRenderFns } from "./PendingApprovalModal.vue?vue&type=template&id=9464639a&scoped=true&"
import script from "./PendingApprovalModal.vue?vue&type=script&lang=js&"
export * from "./PendingApprovalModal.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./PendingApprovalModal.vue?vue&type=style&index=0&id=9464639a&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "9464639a",
  null
  ,true
)

export default component.exports